import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BrickSettingsService, PresenceDurationBrickSettingRemoteDto } from 'src/generated/swagger';
import { IBrickSettingStateModel, SpecificBrickSettingsStateBase } from '../specific-brick-settings-base';
import { ChangeShowDurationAsText, ChangeShowProgressbar } from './presence-duration-brick-settings.actions';

export interface PresenceDurationBrickSettingsStateModel extends IBrickSettingStateModel<PresenceDurationBrickSettingRemoteDto> {}

function getDefaultSpecificBrickSetting(): PresenceDurationBrickSettingRemoteDto {
   return {
      showProgressbar: true,
      showDurationAsText: false,
      commonBrickSettingRemoteDto: null,
   };
}

@State<PresenceDurationBrickSettingsStateModel>({
   name: 'presenceDurationBrickSettings',
   defaults: {
      specificBrickSettings: {
         brickSettings: {},
         brickSettingsEditMode: null,
      },
   },
})
@Injectable()
export class PresenceDurationBrickSettingsState extends SpecificBrickSettingsStateBase<PresenceDurationBrickSettingRemoteDto>(getDefaultSpecificBrickSetting) {
   constructor(private brickSettingsService: BrickSettingsService, store: Store) {
      super(store);
   }

   @Action(ChangeShowProgressbar)
   @ImmutableContext()
   public changeShowProgressbar(ctx: StateContext<PresenceDurationBrickSettingsStateModel>, action: ChangeShowProgressbar) {
      ctx.setState((state: PresenceDurationBrickSettingsStateModel) => {
         const brickSettingModel = PresenceDurationBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showProgressbar = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });

      if (action.show) {
         ctx.dispatch(new ChangeShowDurationAsText(action.brickInstanceId, false));
      }
   }

   @Action(ChangeShowDurationAsText)
   @ImmutableContext()
   public changeShowDurationAsText(ctx: StateContext<PresenceDurationBrickSettingsStateModel>, action: ChangeShowDurationAsText) {
      ctx.setState((state: PresenceDurationBrickSettingsStateModel) => {
         const brickSettingModel = PresenceDurationBrickSettingsState.getSettingModelOrDefault(state, action.brickInstanceId);
         brickSettingModel.showDurationAsText = action.show;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });

      if (action.show) {
         ctx.dispatch(new ChangeShowProgressbar(action.brickInstanceId, false));
      }
   }

   protected doSaveSpecificSettings(brickInstanceId: string, brickSetting: PresenceDurationBrickSettingRemoteDto): Observable<any> {
      return this.brickSettingsService.changePresenceDurationBrickSettings({
         brickInstanceId: brickInstanceId,
         settings: brickSetting,
      });
   }
}
